import axios from 'axios';
import { onMounted } from 'vue';
import { useStoreSsPlayer } from '~/stores/softswiss/player';

export const useClickTracker = () => {
  const apiUrl = '/backend/track';

  const generateAndStoreUniqId = () => {
    if (!localStorage.getItem('uniq_id')) {
      const id = crypto.randomUUID();
      localStorage.setItem('uniq_id', id);
      return id;
    }
    return localStorage.getItem('uniq_id');
  };

  const getUniqId = (): string => {
    return localStorage.getItem('uniq_id') || '';
  };

  const canTrackStag = (stag: string): boolean => {
    const lastClickRaw = localStorage.getItem('last_stag_click');
    if (!lastClickRaw) {
      return true;
    }

    try {
      const lastClick = JSON.parse(lastClickRaw);
      const now = Date.now();
      const weekMs = 7 * 24 * 60 * 60 * 1000;

      return lastClick.stag !== stag || now - new Date(lastClick.timestamp).getTime() > weekMs;
    } catch {
      return true;
    }
  };

  const markStagTracked = (stag: string) => {
    localStorage.setItem(
      'last_stag_click',
      JSON.stringify({ stag, timestamp: new Date().toISOString() })
    );

    if (!localStorage.getItem('og_stag_clicked')) {
      localStorage.setItem(
        'og_stag_clicked',
        JSON.stringify({ stag, timestamp: new Date().toISOString() })
      );
    }
  };

  const trackClick = async (current_stag: string) => {
    if (process.server) {
      return;
    }
    if (!canTrackStag(current_stag) || useStoreSsPlayer().isPlayerAuthorised) {
      return;
    }

    markStagTracked(current_stag);

    const ogStagRaw = localStorage.getItem('og_stag_clicked');
    let original_stag = '';
    let original_click_time = null;

    if (ogStagRaw) {
      try {
        const parsed = JSON.parse(ogStagRaw);
        original_stag = parsed.stag || '';
        original_click_time = parsed.timestamp || null;
      } catch {}
    }

    const is_stag_changed = current_stag !== original_stag;

    const body = {
      current_stag,
      original_stag,
      is_stag_changed,
      timestamp: new Date().toISOString(),
      original_timestamp: original_click_time,
      uniq_id: getUniqId(),
      domain: window.location.host,
    };

    try {
      await axios.post(apiUrl, body);
    } catch (err) {
      console.error('click err:', err);
    }
  };

  onMounted(() => {
    if (!process.server) {
      generateAndStoreUniqId();
    }
  });

  return {
    trackClick,
    getUniqId,
  };
};
